module.exports = __webpack_public_path__ + "media/match_succ.2a51c3b6.wav";